// Pure CSV parsers for fabric color / material imports

const parseRows = (csvText) => {
  const lines = csvText.trim().split('\n');
  if (lines.length < 2) return [];
  const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
  return lines.slice(1).map(line => {
    const values = line.split(',').map(v => v.trim());
    return Object.fromEntries(headers.map((h, i) => [h, values[i] || '']));
  });
};

export const parseColorsCSV = (csvText) =>
  parseRows(csvText).reduce((acc, row) => {
    if (!row.name) return acc;
    const sale = row.is_on_sale ?? row.sale;
    acc.push({
      name: row.name,
      hex_color: row.hex_color || row.hex || undefined,
      code: row.code || undefined,
      image_url: row.image_url || row.image || undefined,
      is_on_sale: sale !== undefined ? (sale.toLowerCase() === 'true' || sale === '1') : undefined,
      is_active: true,
      is_visible_online: true,
    });
    return acc;
  }, []);

export const parseMaterialsCSV = (csvText) =>
  parseRows(csvText).reduce((acc, row) => {
    if (!row.name) return acc;
    const price = row.base_price || row.price;
    acc.push({
      name: row.name,
      description: row.description || undefined,
      composition: row.composition || undefined,
      weight: row.weight || undefined,
      base_price: price ? (parseFloat(price) || null) : undefined,
      image_url: row.image_url || row.image || undefined,
      is_active: true,
      is_visible_online: true,
    });
    return acc;
  }, []);
